import { WhiteLogo } from "@/components/Icons/Icons";
import { TenantImage } from "@/components/Images/TenantImage";
import { NavigationLink } from "@/components/Navigation/NavigationLink";
import { AppText } from "@/components/Text/AppText";
import { useAppSelector } from "@/hooks/types";
import { getTenant } from "@/store/tenant/selectors";
import { addUTMParams } from "@/utils/tracking";

export const FooterBranding = () => {
    const tenant = useAppSelector(getTenant);
    if (!tenant) return null;
    const { externalLinks, tagLine, contactEmail, name } = tenant;

    return (
        <div className="flex flex-col items-start gap-2">
            <a
                href={addUTMParams(externalLinks.homepage, {
                    source: "app",
                    medium: "internal_link",
                    campaign: "footer_navigation",
                    content: "logo",
                })}
                aria-label={name}
            >
                <TenantImage
                    imageType="footerLogo"
                    alt={name}
                    className="h-6 w-auto"
                />
            </a>
            {tagLine && (
                <AppText
                    variant="footnote"
                    className="mt-2 text-xs text-white/75"
                >
                    {tagLine}
                </AppText>
            )}
            {contactEmail && (
                <NavigationLink
                    to={`mailto:${contactEmail}`}
                    className="!px-0 !text-xs text-white/90 transition-colors hover:text-white"
                >
                    {contactEmail}
                </NavigationLink>
            )}
        </div>
    );
};
